import { Box, Typography } from "@mui/material";
import { userPages } from "../TracksPageComponents/types";
import { useContext } from "react";
import LockIcon from "@mui/icons-material/Lock";
import { TalkJsContext, TalkJsContextInterface } from "../../contexts";
import {
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../contexts";
import { useAuth0 } from "@auth0/auth0-react";
import { styles } from "../TracksPageComponents/styles";
import { useNavigate, useParams } from "react-router-dom";
import { DrawerPagesProps } from "./types";

export const DrawerPages: React.FC<DrawerPagesProps> = ({
  currentUser,
  currentPage,
  setCurrentPage,
  session,
  setInbox,
}) => {
  const { loginWithRedirect } = useAuth0();
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const { isEnterpriseAccount } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <>
      <Box sx={{ marginTop: "20px" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {userPages.map((page, i) => {
            const isProjectsPage =
              window.location.href.includes("project") && id;
            const showProjectsPage = currentUser && isEnterpriseAccount;
            if (page.name === "Projects" && !showProjectsPage) {
              return null;
            }
            return (
              <Box
                sx={{
                  ...styles.pageNameContainer,
                  ...{
                    display:
                      talkJsContext.isChatOpen && page.name === "Messages"
                        ? "none"
                        : "flex",
                    backgroundColor:
                      page.name === currentPage ||
                      (isProjectsPage && page.name === "Projects")
                        ? "#1F242F"
                        : "",
                  },
                }}
                key={i}
                onClick={() => {
                  if (currentUser || page.name === "Explore") {
                    if (page.name !== "Messages") {
                      setCurrentPage(page.name);
                      navigate(page.route);
                    } else {
                      if (session && setInbox) {
                        const talkInbox = session.createInbox();
                        setInbox(talkInbox);
                        talkJsContext.setIsChatOpen(true);
                      }
                    }
                  } else {
                    loginWithRedirect({
                      appState: { returnTo: "/my-tracks" },
                      authorizationParams: { screen_hint: "signup" },
                    });
                  }
                }}
              >
                <img
                  style={{ filter: "contrast(0%)" }}
                  src={page.iconPath}
                  alt="icon"
                />
                <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                  {page.name}
                </Typography>
                {!currentUser && page.name !== "Explore" ? (
                  <LockIcon sx={{ fontSize: "18px" }} />
                ) : null}
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};
